module.exports = (parcelRequire.load("2dj4u")).then(() => parcelRequire('e8X1q'));